<div
  [ngClass]="{
    'entry-header-small-screen': isSmallScreen(),
    'entry-header-large-screen': isLargeScreen()
  }"
>
  <div
    class="flex flex-wrap flex-row items-center justify-between w-full"
    [appDynamicStyles]="{
      'column-gap': {
        zoomout: '28px',
        zoomin: '14px'
      },
      'row-gap': {
        zoomout: '12px',
        zoomin: '6px'
      }
    }"
  >

    <!-- Title -->
    <div class="flex items-center gap-2 min-w-0">
      <span class="entry-header-title">{{ title }}</span>
    </div>


    <!-- Action Buttons -->
    <div
      class="flex flex-wrap flex-row items-center justify-end gap-3 flex-1"
    >

      <!-- New Entry Button -->
      <button
        mat-raised-button
        matTooltip="Add new time entry"
        matTooltipClass="sidenavTooltip"
        class="flex items-center entry-page-button"
        (click)="newClicked.emit()"
        [appDynamicStyles]="{
          'height': {
            zoomout: '40px',
            zoomin: '30px'
          },
          'padding': {
            zoomout: '8px 12px 8px 8px',
            zoomin: '4px 8px 4px 4px'
          }
        }"
      >
        <div class="flex flex-row gap-1">

          <div
            class="flex items-center"
            [appDynamicStyles]="{
              'height': {
                zoomout: '28px',
                zoomin: '14.5px'
              }
            }"
          >
            <mat-icon>add</mat-icon>
          </div>

          <div
            class="flex items-center font-sans"
            [appDynamicStyles]="{
              'font-size': {
                zoomout: '16px',
                zoomin: '14.5px'
              },
              'height': {
                zoomout: '28px',
                zoomin: '14.5px'
              }
            }"
          >
            New
          </div>

        </div>
      </button>


      <!-- Save Button -->
      <button
        mat-raised-button
        class="flex items-center entry-page-button disabled:opacity-50 cursor-not-allowed enabled:cursor-pointer"
        (click)="saveClicked.emit()"
        [disabled]="isSaveDisabled"
        [appDynamicStyles]="{
          'height': {
            zoomout: '40px',
            zoomin: '30px'
          },
          'padding': {
            zoomout: '8px 12px 8px 8px',
            zoomin: '4px 8px 4px 4px'
          }
        }"
      >
        <div class="flex flex-row gap-1">

          <div
            class="flex items-center"
            [appDynamicStyles]="{
              'height': {
                zoomout: '28px',
                zoomin: '14.5px'
              }
            }"
          >
            <mat-icon>save</mat-icon>
          </div>

          <div
            class="flex items-center font-sans"
            [appDynamicStyles]="{
              'font-size': {
                zoomout: '16px',
                zoomin: '14.5px'
              },
              'height': {
                zoomout: '28px',
                zoomin: '14.5px'
              }
            }"
          >
            Save
          </div>

        </div>
      </button>


      <!-- Delete Entries Button -->
      <button
        mat-raised-button
        class="flex items-center entry-page-button disabled:opacity-50 cursor-not-allowed enabled:cursor-pointer"
        (click)="deleteClicked.emit()"
        [disabled]="isDeleteDisabled"
        [appDynamicStyles]="{
          'height': {
            zoomout: '40px',
            zoomin: '30px'
          },
          'padding': {
            zoomout: '8px 12px 8px 8px',
            zoomin: '4px 8px 4px 4px'
          }
        }"
      >
        <div class="flex flex-row gap-1">

          <div
            class="flex items-center"
            [appDynamicStyles]="{
              'height': {
                zoomout: '28px',
                zoomin: '14.5px'
              }
            }"
          >
            <mat-icon>delete_outline</mat-icon>
          </div>

          <div
            class="flex items-center font-sans"
            [appDynamicStyles]="{
              'font-size': {
                zoomout: '16px',
                zoomin: '14.5px'
              },
              'height': {
                zoomout: '28px',
                zoomin: '14.5px'
              }
            }"
          >
            Delete Checked
          </div>

        </div>
      </button>


      <!-- Reset Button -->
      <div>

        <button
          [matMenuTriggerFor]="resetMenu"
          mat-raised-button
          class="flex items-center entry-page-button"
          [appDynamicStyles]="{
            'height': {
              zoomout: '40px',
              zoomin: '30px'
            },
            'padding': {
              zoomout: '8px 12px 8px 8px',
              zoomin: '4px 8px 4px 4px'
            }
          }"
        >
          <div class="flex flex-row gap-1">

            <div
              class="flex items-center"
              [appDynamicStyles]="{
                'height': {
                  zoomout: '28px',
                  zoomin: '14.5px'
                }
              }"
            >
              <mat-icon>restore</mat-icon>
            </div>

            <div
              class="flex items-center font-sans"
              [appDynamicStyles]="{
                'font-size': {
                  zoomout: '16px',
                  zoomin: '14.5px'
                },
                'height': {
                  zoomout: '28px',
                  zoomin: '14.5px'
                }
              }"
            >
              Reset
            </div>

          </div>
        </button>


        <!-- Reset Menu -->
        <mat-menu
          #resetMenu="matMenu"
          [overlapTrigger]="false"
          class="bg-white shadow-2xl rounded"
          [xPosition]="'after'"
        >
          <button
            matTooltip="Reset time entry changes"
            class="enabled:cursor-pointer disabled:opacity-50 cursor-not-allowed mat_option--Itemstyle"
            mat-menu-item
            (click)="resetClicked.emit()"
            [appDynamicStyles]="{
              'height': {
                zoomout: '40px',
                zoomin: '30px'
              },
              'padding': {
                zoomout: '8px',
                zoomin: '4px'
              }
            }"
          >
            <mat-icon class="h-4 w-4 min-h-4 min-w-4">
              bar_chart
            </mat-icon>

            <span>Reset Data</span>
          </button>
        </mat-menu>

      </div>

    </div>


    <!-- Grid / Calendar Toggle -->
    <div class="view-toggle flex items-center">

      <button
        type="button"
        class="view-toggle-option flex items-center"
        [class.view-toggle-option--active]="view === 'grid'"
        (click)="setView('grid')"
      >
        <mat-icon>grid_view</mat-icon>
        <span>Grid</span>
      </button>

      <button
        type="button"
        class="view-toggle-option flex items-center"
        [class.view-toggle-option--active]="view === 'calendar'"
        (click)="setView('calendar')"
      >
        <mat-icon>calendar_view_month</mat-icon>
        <span>Calendar</span>
      </button>

    </div>

  </div>
</div>